import firebase from 'firebase/app';
import 'firebase/messaging'; // We are using Firebase messaging services
// import { history } from '../../../lib/redux';
// import { useNavigate } from 'react-router-dom';

import controller from './controller';
import { URL_ORDERS_VIEW_ONE } from '../../../lib/router/url';

const TOKEN_TYPE_REF_VALUE_ID = 143;

if (firebase.messaging.isSupported()) {
  firebase.initializeApp({
    apiKey: process.env.FCM_API_KEY,
    authDomain: process.env.FCM_AUTH_DOMAIN,
    databaseURL: process.env.FCM_DATABASE_URL,
    projectId: process.env.FCM_PROJECT_ID,
    storageBucket: process.env.FCM_STORAGE_BUCKET,
    messagingSenderId: process.env.FCM_MESSAGING_SENDER_ID,
    appId: process.env.FCM_APP_ID,
    measurementId: process.env.FCM_MEASUREMENT_ID,
  });
}

// тернарный вместо `&&`: тип Messaging | null вместо false | Messaging (иначе tsc
// не даёт звать getToken на юнионе с false); рантайм-семантика идентична
const fcm: firebase.messaging.Messaging | null = firebase.messaging.isSupported()
  ? firebase.messaging()
  : null;

const sendTokenToTheServer = async (userId) => {
  const token = await fcm.getToken();
  if (token && userId) {
    controller.sendToken({
      userId,
      token,
      tokenTypeId: TOKEN_TYPE_REF_VALUE_ID,
    });
  }
};

const listenPush = async (userId) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  // const navigate = useNavigate();
  if (('Notification' in window) && firebase.messaging.isSupported()) {
    const permission = await Notification.requestPermission();

    if (permission === 'granted') {
      sendTokenToTheServer(userId);
    }

    fcm.onTokenRefresh(() => {
      sendTokenToTheServer(userId);
    });

    fcm.onMessage(payload => {
      const { notification, data } = payload;
      const { title, body } = notification;
      // eslint-disable-next-line no-new
      const push = new Notification(title, { body });
      push.onclick = () => {
        // navigate(`${ URL_ORDERS_VIEW_ONE }/${ data.orderId }`);
        window.location.href = `${ URL_ORDERS_VIEW_ONE }/${ data.orderId }`;
        push.close();
      };
    });
  }
};

export { fcm, listenPush };
